<template>
  <div class="new-features">
    <div
      class="new-features__wrap"
       :style="{
        'width': maxWidth+'px',
        'max-width': maxWidth+'px',
       }"
    >
      <div class="new-features__title">{{ title }}:</div>
      <div class="new-features__items">
        <div
          v-for="item in items"
          class="new-features__item"
        >{{ item.title }}. <span class="new-features__date">Ориентировочно: {{ item.date }}.</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {type: String, default: null},
    items: {type: Array, default: () => []},
    maxWidth: {type: Number, default: 1300},
  }
}
</script>

<style lang="scss">
.new-features {
  display: flex;
  justify-content: center;

  .new-features__wrap {
    display: flex;
    align-items: center;
    padding: 40px 20px;
    flex-direction: column;
  }
  .new-features__title {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .new-features__item {
    font-size: 16px;
    margin: 5px 0;
  }
  .new-features__date {
    font-size: 14px;
    color: #858585;
  }
}
</style>